'use client';
import { useRef, useEffect, useMemo } from 'react';

/**
 * Гарантирует стабильную ссылку на возвращаемую функцию.
 *
 * Преобразует функцию обратного вызова к ref,
 * чтобы всегда использовать актуальную версию функции и предотвращать
 * ненужные отрисовки или повторное выполнение эффектов, которые зависят
 * от этой функции.
 *
 * Отличие от useCallback заключается в том, что не требуется указывать массив зависимостей.
 *
 * @param {Function} action - Функция обратного вызова, которую необходимо отслеживать.
 * @returns {Function} Функция обратного вызова,
 * которая всегда будет актуальной версией переданной функции и будет иметь стабильную ссылку.
 */ const useCallbackRef = (action)=>{
    const callbackRef = useRef(action);
    useEffect(()=>{
        callbackRef.current = action;
    });
    return useMemo(()=>(...args)=>callbackRef.current == null ? void 0 : callbackRef.current.call(callbackRef, ...args), []);
};

export { useCallbackRef };
//# sourceMappingURL=useCallbackRef.js.map
